import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { formatMoneyValue } from "@utils/Currency";
import styles from "./style.module.scss";
import moment from "moment";
import { DebitnoteDataType } from "@/api/DebitnoteApi";
import { InvoiceApi, InvoiceDataType } from "@/api/InvoiceApi";
import { renderEDocumentStatusOffCanvasTrigger } from "@utils/ModelIndexUtils";

type DebitnoteInvoiceSelectProp = {
  priceNote?: boolean
}
const DebitnoteInvoiceSelect = (props: DebitnoteInvoiceSelectProp) => {
  const { priceNote = false } = props
  const modelRef = useRef<ModelIndexHandle>(null);

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Lista de Facturas"
      backUrl="/user/dashboard-accounting"
    >
      <ModelIndex<InvoiceDataType>
        ref={modelRef}
        messages={{
          noResults: "No hay facturas creadas aun"
        }}
        meiliConfig={{
          index: "invoices",
          sort: ["fecha:desc"],
        }}
        fetchData={(...args) => InvoiceApi.fetchAll(...args)}
        filterProps={[
          {
            key: "sequence",
            filterType: "contains"
          },
          {
            key: "invoice_key",
            filterType: "contains"
          },
          {
            key: "numero",
            filterType: "eq",
            type: "number"
          }
        ]}
        primaryProperties={[
          {
            key: "sequence",
            highlighted: true,
            className: styles.sequence
          },
          {
            key: (d) => d.client?.nombre || "",
            alignment: "Start"
          },
        ]}
        primaryPropertiesSizing={
          [
            { sm: "4", xs: "12" },
            { sm: "8", xs: "12" }
          ]
        }
        secondaryProperties={[
          {
            key: (data) => {
              const date = moment(data.fecha, "YYYY-MM-DD")
              return date.format("DD-MM-YYYY")
            },
            title: "Fecha",
          },
          {
            key: (data) => renderEDocumentStatusOffCanvasTrigger(data, { model: "Invoice", id: `${data.id}` }),
            title: "Estado ATV"
          },
          {
            key: (data) => {
              if ("currency_id" in data) {
                return formatMoneyValue(data.total, (data as any).currency_id)
              }
              return formatMoneyValue(data.total, data.currency.currency_id)
            },
            title: "Total",
            highlighted: true
          }
        ]}
        secondaryPropertiesSizing={
          [
            { sm: "4", md: "2" },
            { sm: "4", md: "3" },
            { sm: "4", md: "2" }
          ]
        }
        listActions={[
          {
            href: priceNote ? "/user/debitnotes/addByPrice/{:id}" : "/user/debitnotes/add/{:id}",
            actionTitle: "Crear Nota de Debito",
            iconProps: { icon: faXmark, className: styles.cancelBtn }
          },
        ]}
      >
      </ModelIndex>
    </PageContainer >
  );
}

export default DebitnoteInvoiceSelect;
